import { render, staticRenderFns } from "./facility-item-details.vue?vue&type=template&id=90283d38&scoped=true"
import script from "./facility-item-details.vue?vue&type=script&lang=js"
export * from "./facility-item-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90283d38",
  null
  
)

export default component.exports